// @ts-nocheck
import * as React from "react";
import { useEffect } from "react";
import ProgressBar from 'react-customizable-progressbar'
import { SolutionChart } from "../../config/interfaces";
import Rellax from "rellax";
import anime from "animejs";
import { useApi } from '../../config/state'


// Components
import Loader from "../Loader";
import HomeCarousel from "../HomeCarousel";
import Modal from "../Modal";
import { Sky, Lake } from "../BgAnimation";
import BtnSumate from "../BtnSumate"
import TitleAnimate from "../TitleAnimate";
import ScrollAnimation from "../ScrollAnimation";

const THEMEURL = window.drupalSettings ? window.drupalSettings.path.themeUrl : 'themes/custom/mx_aguas_firmes_theme';

export const Home = ({ data, logos, setLoading, loading }: HomeCmp) => {

    const {fetchHome, data: dataApi} = useApi(state => (state))
    
    useEffect(() => {
        fetchHome()
    }, [])
    // console.log(dataApi.data);
    
    let maxApan: string;
    let minApan: string;
    dataApi.data !== undefined ? maxApan = dataApi.data[0].progress[0].projected : '';
    dataApi.data !== undefined ? minApan = dataApi.data[0].progress[0].current : '';
    

    let maxCalera: string;
    let minCalera: string;
    dataApi.data !== undefined ? maxCalera = dataApi.data[0].progress[1].projected : '';
    dataApi.data !== undefined? minCalera = dataApi.data[0].progress[1].current : '';
    
    const refMoreButton = React.useRef<any>(null)
    const [isVisbleModal, setIsVisbleModal] = React.useState<boolean>(false)
    
    const loadParallax = () => {
        new Rellax('.rellax', {
            vertical: false
        });
        document.addEventListener('mousemove', parallaxImg)
    }

    const parallaxImg = (e) => {
        let images = document.querySelectorAll('.parallax-effect')
        images.forEach((img) => {
            let moving_value = img.getAttribute("data-rellax-speed")
            let x = (e.clientX * moving_value) / 100;
            let y = (e.clientY * moving_value) / 200;
            img.style.transform = "translate(" + x + "px," + y + "px)";
        })
    }

    const animateHeaderElements = () => {
        anime({
            targets: '.home__btn-play',
            opacity: [0, 1],
            delay: 2000,
            duration: 4000,
        })
        anime({
            targets: '.home__more',
            opacity: [0, 1],
            delay: 2000,
            duration: 4000,
        })
        anime({
            targets: '.sponsors__title',
            opacity: [0, 1],
            delay: 3500,
            duration: 4000,
        })
        anime({
            targets: '.sponsors__list',
            opacity: [0, 1],
            delay: 4500,
            duration: 4000,
        })
    }

    const hideModal = () => {
        setIsVisbleModal(false)
    }

    React.useEffect(() => {
        window.onload = function () {
            setLoading(false)
            animateHeaderElements()
        }
        loadParallax()
    }, []);

    return (
        <main className='home-container'>
            <section className='home__header taC'>
                <Sky />
                <h1 className='home__title'><TitleAnimate text={!loading ? data.field_title : ''} type={'fadeUp'} /></h1>

                <button className="home__btn" ref={refMoreButton} data-content={data.field_videolink}><img className='home__btn-play' src={`/${THEMEURL}/sources/dist/assets/images/icons/play-button.svg`} alt="Boton Reproducir" width='60' height='60' /></button>
                <p className='home__more'>{data.field_vide_str}</p>
                <div className='sponsors'>
                    <h2 className='sponsors__title'>{data.langcode == 'es' ? 'Un proyecto de' : 'A project of'}</h2>
                    <ul className='sponsors__list'>
                        {logos.map((logo: SpecificLink, index: number) => (
                            <li className='sponsors__list-item' key={index}>
                                <img src={logo.description} alt={logo.title} title={logo.title} />
                            </li>
                        ))}
                    </ul>
                </div>
                <ScrollAnimation />
            </section>
            {!loading && <BtnSumate />}
            <section className='home__body'>
                <Lake />
                <article className='home__body-article'>
                    <h2 className='home__subtitle' data-aos='fade-up' data-aos-anchor-placement='center-bottom'>{data.field_subtitle}</h2>
                    <div className='home__description' data-aos='fade-up' data-aos-anchor-placement='center-bottom' dangerouslySetInnerHTML={{ __html: data.field_desc }}></div>
                </article>
                <section id='testCanvas' className='home__section-image' data-aos='zoom-in' data-aos-anchor-placement='center-bottom'>
                    <CircleChart className="progress-calera-chart" chartData={{ footer: [{ title: 'hola', alt: 'alt' }], information: 'information', label: 'label', max_value: `${maxCalera}`, min_value: `${minCalera}`, title: 'titulo' }} />
                    <CircleChart className="progress-apan-chart" chartData={{ footer: [{ title: 'hola', alt: 'alt' }], information: 'information', label: 'label', max_value: `${maxApan}`, min_value: `${minApan}`, title: 'titulo' }} />
                </section>
            </section>
            <HomeCarousel slideList={data.home_slide} slideTitle={data.home_slide_title} />
            <Modal refButton={refMoreButton} />
            <section id="lightbox" className="modal hide">
                <div className="modal__container modal__container--video">
                    <span className="modal__close" data-modal-close></span>
                    <div id="container-stories"></div>
                </div>
            </section>
        </main>
    )
}

const CircleChart = ({ chartData, className }: { chartData: SolutionChart, className: string }) => {
    const [progress, setProgress] = React.useState<string>(0)

    const calculatePercentage = (total: string, fill: string) => {
        return Math.round(parseInt(fill) * 100 / parseInt(total))
    }

    React.useEffect(() => {
        if(chartData.max_value != undefined || chartData.min_value != undefined) {
            let num = calculatePercentage(chartData.max_value, chartData.min_value);
            if(!isNaN(num)) {
                setProgress(num)
            }
        }
    }, [chartData])
    
    return (
        <div className={`progress-percentage ${className}`} data-aos='fade-in' data-aos-delay="300">
            <ProgressBar
                className="progress-percentage__chart"
                progress={progress}
                radius={100}
                strokeWidth={35}
                strokeColor={'#39BDE5'}
                trackStrokeWidth={35}
                trackStrokeColor={'#4D75B4'}
                initialAnimation={true}>
                <div className='progress-percentage__body'>
                    <span className="progress-percentage__indicator">{progress}%</span>
                </div>
            </ProgressBar>
        </div>
    )
}

export default Loader(Home)
